import { createAction } from '../util/index.js';

export const selectStatusButton = createAction('STATUS_BUTTON_SELECT', statusButtonVal => statusButtonVal)
export const durationChanged = createAction('DURATION_CHANGE', requestObject => requestObject)
export const cancelCalls = createAction('CANCEL_CALL', requestObject => requestObject)
export const filterChanged = createAction('FILTER_CHANGE', requestObject => requestObject);
export const searchAllPage = createAction('SEARCHAll_PAGE', requestObject => requestObject);
export const dispalyColumnsChange = createAction('COLUMNS_CHANGE', requestObject => requestObject);